import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import * as z from "zod/v4";

export const getToteByBarcode = {
  name: "getToteByBarcode" as const,
  input: z.object({ barcode: z.string() }),
  output: RedoFulfillmentToteSchema,
};

export type GetToteByBarcodeInput = z.infer<typeof getToteByBarcode.input>;
